import Cookies from 'universal-cookie';
const cookies = new Cookies();
import {
	CREATE_ADMIN_USER_START,
	CREATE_ADMIN_USER_SUCCESS,
	CREATE_ADMIN_USER_ERROR,
} from '../../../constants';
import { setRuntimeVariable } from '../../runtime';
import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import { getAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import { getPrivileges } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';
import { adminLoginQuery as query } from '../../../lib/graphql';
import { siteSettings } from '../siteSettings';


export const login = (email, password) => {
	return async (dispatch, getState, { client }) => {

		try {
			await dispatch({
				type: CREATE_ADMIN_USER_START,

			});

			dispatch(setLoaderStart('AdminLogin'));

			const { data } = await client.query({
				query,
				variables: {
					email,
					password,
				},
				fetchPolicy: 'network-only'
			});

			dispatch(setLoaderComplete('AdminLogin'));

			if (data?.adminUserLogin?.status == 200) {
				// SECURITY: set the session cookie SERVER-SIDE as httpOnly (XSS can't read it).
				// Falls back to a client cookie only if the server call fails. (secure+sameSite.)
				{
					const _token = data?.adminUserLogin?.token;
					const _ttl = data?.adminUserLogin?.expiresIn;
					try {
						const r = await fetch('/auth/session', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							credentials: 'same-origin',
							body: JSON.stringify({ token: _token, maxAge: _ttl }),
						});
						if (!r.ok) throw new Error('session set failed');
					} catch (e) {
						cookies.set('id_token', _token, { path: '/', maxAge: _ttl, secure: true, sameSite: 'lax' });
					}
				}
				await dispatch({
					type: CREATE_ADMIN_USER_SUCCESS,
				});
				dispatch(setRuntimeVariable({
					name: 'isAdminAuthenticated',
					value: true,
				}));

				dispatch(setRuntimeVariable({
					name: 'isSuperAdmin',
					value: data?.adminUserLogin?.isSuperAdmin
				}));
				dispatch(getAdminUser());
				dispatch(getPrivileges());
				dispatch(siteSettings());

				history.push('/siteadmin');
				return false;
			} else {

				if (data?.adminUserLogin?.isSuperAdmin) {
					dispatch(setRuntimeVariable({
						name: 'isAdminAuthenticated',
						value: true,
					}));
					dispatch(setRuntimeVariable({
						name: 'isSuperAdmin',
						value: data?.adminUserLogin?.isSuperAdmin
					}));
					dispatch(getAdminUser());
					dispatch(getPrivileges());
					dispatch(siteSettings());

				}
				await dispatch({
					type: CREATE_ADMIN_USER_ERROR,
				});

				return data?.adminUserLogin?.errorMessage;
			}

		} catch (error) {
			await dispatch({
				type: CREATE_ADMIN_USER_ERROR,

			});
			dispatch(setLoaderComplete('AdminLogin'));
			return false;
		}
	}
}